/* eslint-disable react/prop-types */
// import logo from '@assets/logo.png';
import classes from './index.module.css';

const TITLE_TEXT = '17TRACK Worry-Free Purchase Resolution Center';

export const Navigation = () => (
  <nav className={classes.navigationBar}>
    <section className={classes.left}>
      {/* <section className={classes.logo}>
        <img src={logo} className={classes.logoIcon} alt="" />
      </section> */}
      <section className={classes.title}>
        {TITLE_TEXT}
      </section>
    </section>
  </nav>
);
